import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';
import useClipboard from 'react-use-clipboard';

import { getReferralItemsByType } from '../../../../../../../util/account-referrals';
import {
  ACCOUNT_REFERRAL_TYPE_DESCRIPTIONS,
  ACCOUNT_REFERRAL_TYPE_HEADERS,
  ACCOUNT_REFERRAL_TYPE,
} from '../../../../../../../constants/account-referrals';
import Button from '../../../../../../../components/global/Button';
import { openModal as openModalAction } from '../../../../../../../actions/modal-actions';
import { getAsset } from '../../../../../../../util/assets';
import ReferralUrlInput from '../../../../Welcome/ShutterbugLanding/components/ReferralUrlInput';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
  accountReferralType: PropTypes.oneOf(Object.values(ACCOUNT_REFERRAL_TYPE)),
  wrapperClassname: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  contentLink: PropTypes.node,
};

const AccountReferralItem = ({
  user,
  accountReferralType,
  className,
  wrapperClassname = '',
  icon,
  contentLink,
}) => {
  const { affiliateUrl, promoCode } = getReferralItemsByType(
    user,
    accountReferralType,
  );

  const [isCopied, setCopied] = useClipboard(promoCode?.code, {
    successDuration: 5000,
  });

  if (!user) {
    return null;
  }

  if (!affiliateUrl && !promoCode) {
    return null;
  }

  const classes = classNames({
    'account-referral-item': true,
    [className]: !!className,
  });

  return (
    <div className={wrapperClassname}>
      <div className={classes}>
        <div className="max-w-75p">
          <div className="account-referral-item-main">
            {icon && (
              <img
                src={getAsset(icon)}
                className="account-referral-item-icon"
                alt={ACCOUNT_REFERRAL_TYPE_HEADERS[accountReferralType]}
              />
            )}
            <h3 className="mb-2">
              {ACCOUNT_REFERRAL_TYPE_HEADERS[accountReferralType]}
            </h3>
            <p>
              {ACCOUNT_REFERRAL_TYPE_DESCRIPTIONS[accountReferralType]}
              <br />
              {contentLink}
            </p>
          </div>

          <div className="mt-auto">
            {promoCode && (
              <Fragment>
                <p className="mb-1">Share your code:</p>
                <Button btnStyle="reset" onClick={setCopied}>
                  <div className="account-referral-item-promo-code">
                    {promoCode.code}{' '}
                    {isCopied && <span className="text-xs">Copied!</span>}
                  </div>
                </Button>
              </Fragment>
            )}

            {promoCode && affiliateUrl && (
              <p className="text-extra-bold text-sm">OR</p>
            )}

            {affiliateUrl && (
              <div>
                <p>Share your unique link:</p>
                <ReferralUrlInput
                  url={affiliateUrl.url}
                  className="mt-0 account-referral-item-link"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  openModal: openModalAction,
};

AccountReferralItem.propTypes = propTypes;

export default compose(connect(null, mapDispatchToProps))(AccountReferralItem);
